import React, { Component, PureComponent } from "react";
import { PieChart, Pie, Sector, Cell, Legend, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { connect } from 'react-redux'
import { MESSAGE } from '../../../../constants/dictionaries'
import Constant, { functionsCode, groupFunctionsCode } from '../../../../constants/constant';
import Message from "../../../../components/Messages";
import Helper from '../../../../helper/helper';
import styles from './index.module.scss';
//component
import { Table, Row, Col } from 'antd';

//helper

class SoLieuBieuDoMB extends Component {
    constructor(props) {
        super(props);
        const { functions } = props;
        this.state = {
            data_gp: [],
            data_bcdk: [],
            tittle: "",
            tieude: "",
            data: {}
        }
    }
    componentDidMount() {
        const { data, datatong } = this.props
        this.setState({
            data_gp: data.giayphep,
            data_bcdk: data.baocaodinhky,
            tittle: data.tittle,
            tieude: data.tieude,
            data: data
        })
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const { data, datatong } = this.props
        if (prevProps.data !== data) {
            this.setState({
                data_gp: data.giayphep,
                data_bcdk: data.baocaodinhky,
                tittle: data.tieude,
                tieude: data.tieude,
                data: data
            })
        }

    }

    handleClick_tongso = (name) => {
        const { functions } = this.props
        const groupFunctions = Helper.handleGroupFunctions(functions, groupFunctionsCode);
        // nuoc thai
        if (name === "Tổng số") {
            {
                groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_XT) ?
                    this.props.history.push('/tai-nguyen-nuoc/xa-thai')
                    :
                    Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
            }
        }
    }
    handleClick = (name) => {


        const { functions } = this.props
        const groupFunctions = Helper.handleGroupFunctions(functions, groupFunctionsCode);
        // nuoc thai
        if (name === "Tổng số") {
            {
                groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_XT) ?
                    this.props.history.push('/tai-nguyen-nuoc/xa-thai')
                    :
                    Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
            }
        }
        else if (name === 'Còn hiệu lực') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_XT) ?
                this.props.history.push('/tai-nguyen-nuoc/xa-thai?Column=FullName&Giayphep_Sort=1&Sort=2&HieuLuc=1&PageNumber=1&PageSize=10')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        else if (name === 'Sắp hết hiệu lực') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_XT) ?
                this.props.history.push('/tai-nguyen-nuoc/xa-thai?HieuLuc=4&PageNumber=1&PageSize=10&Giayphep_Sort=1&Sort=2')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        else if (name === 'Hết hiệu lực') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_XT) ?
                this.props.history.push('/tai-nguyen-nuoc/xa-thai?HieuLuc=3&&PageNumber=1&PageSize=10&Giayphep_Sort=1&Sort=2')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        else if (name === 'Chưa gửi báo cáo') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_XT) ?
                this.props.history.push('/tai-nguyen-nuoc/xa-thai?HieuLuc=1&ISBCDK=2&PageNumber=1&PageSize=10&Giayphep_Sort=1&Sort=2&NangCao=true')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        //nuoc mặt
        else if (name === ' Tổng số') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_NM) ?
                this.props.history.push('/tai-nguyen-nuoc/khai-thac-nuoc-mat')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        else if (name === 'Còn hiệu lực ') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_NM) ?
                this.props.history.push('/tai-nguyen-nuoc/khai-thac-nuoc-mat?Column=FullName&Giayphep_Sort=1&HieuLuc=1&PageNumber=1&PageSize=10')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)

        }
        else if (name === 'Sắp hết hiệu lực ') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_NM) ?
                this.props.history.push('/tai-nguyen-nuoc/khai-thac-nuoc-mat?Column=FullName&Giayphep_Sort=1&HieuLuc=4&PageNumber=1&PageSize=10')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        else if (name === 'Hết hiệu lực ') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_NM) ?
                this.props.history.push('/tai-nguyen-nuoc/khai-thac-nuoc-mat?Column=FullName&Giayphep_Sort=1&HieuLuc=3&PageNumber=1&PageSize=10')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        else if (name === ' Chưa gửi báo cáo') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_NM) ?
                this.props.history.push('/tai-nguyen-nuoc/khai-thac-nuoc-mat?Column=FullName&Giayphep_Sort=1&ISBCDK=2&PageNumber=1&PageSize=10&NangCao=true')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        // nuoc duoi dat
        else if (name === '  Tổng số') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_KTNDD) ?
                this.props.history.push('/tai-nguyen-nuoc/khai-thac-nuoc-duoi-dat')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        else if (name === ' Còn hiệu lực') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_KTNDD) ?
                this.props.history.push('/tai-nguyen-nuoc/khai-thac-nuoc-duoi-dat?Column=FullName&Giayphep_Sort=1&Sort=2&HieuLuc=1&PageNumber=1&PageSize=10')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)

        }
        else if (name === ' Sắp hết hiệu lực') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_KTNDD) ?
                this.props.history.push('/tai-nguyen-nuoc/khai-thac-nuoc-duoi-dat?Column=FullName&Giayphep_Sort=1&Sort=2&HieuLuc=4&PageNumber=1&PageSize=10')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        else if (name === ' Hết hiệu lực') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_KTNDD) ?
                this.props.history.push('/tai-nguyen-nuoc/khai-thac-nuoc-duoi-dat?Column=FullName&Giayphep_Sort=1&Sort=2&HieuLuc=3&PageNumber=1&PageSize=10')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        else if (name === '  Chưa gửi báo cáo') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_KTNDD) ?
                this.props.history.push('/tai-nguyen-nuoc/khai-thac-nuoc-duoi-dat?Column=FullName&Giayphep_Sort=1&Sort=2&HieuLuc=1&ISBCDK=2&PageNumber=1&PageSize=10&NangCao=true')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        // bao cao phe duyet
        else if (name === 'Quyết định phê duyệt') {
            groupFunctions[groupFunctionsCode.DTM].includes(functionsCode.DTM_BCPD) ?
                this.props.history.push('/DTM/bao-cao-phe-duyet?Column=FullName&PageNumber=1&PageSize=10')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        } else if (name === 'Chờ phê duyệt ') {
            groupFunctions[groupFunctionsCode.BCDN].includes(functionsCode.BCDN_DTM) ?
                this.props.history.push('/BCDN/DTM?Column=&PageNumber=1&PageSize=10&Sort=DESC&StrSearch=&TrangThai=2')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        // de an phe duyet
        else if (name === ' Quyết định phê duyệt') {
            groupFunctions[groupFunctionsCode.BVMT].includes(functionsCode.BVMT_DACT) ?
                this.props.history.push('/bao-ve-moi-truong/de-an-chi-tiet?Column=FullName&PageNumber=1&PageSize=10')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        } else if (name === 'Chờ phê duyệt  ') {
            groupFunctions[groupFunctionsCode.BCDN].includes(functionsCode.BCDN_BVMT) ?
                this.props.history.push('/BCDN/BVMT?Column=&PageNumber=1&PageSize=10&Sort=DESC&StrSearch=&TrangThai=2')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        // bao cao dinh ky
        else if (name === 'Tổng số ') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_BCDK) ?
                this.props.history.push('/tai-nguyen-nuoc/bao-cao-dinh-ky?Column=&NhomCongTrinh=2&PageNumber=1&PageSize=10')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        else if (name === 'Tổng số  ') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_BCDK) ?
                this.props.history.push('/tai-nguyen-nuoc/bao-cao-dinh-ky?Column=&NhomCongTrinh=3&PageNumber=1&PageSize=10')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        else if (name === 'Tổng số   ') {
            groupFunctions[groupFunctionsCode.TNN].includes(functionsCode.TNN_BCDK) ?
                this.props.history.push('/tai-nguyen-nuoc/bao-cao-dinh-ky?Column=&NhomCongTrinh=1&PageNumber=1&PageSize=10')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        else if (name === ' Tổng số ') {
            groupFunctions[groupFunctionsCode.DTM].includes(functionsCode.DTM_BCDK) ?
                this.props.history.push('/DTM/bao-cao-dinh-ky?&NhomCongTrinh=2&PageNumber=1&PageSize=10')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }
        else if (name === ' Tổng số  ') {
            groupFunctions[groupFunctionsCode.BVMT].includes(functionsCode.BVMT_BCDK) ?
                this.props.history.push('/bao-ve-moi-truong/bao-cao-dinh-ky?&PageNumber=1&PageSize=10')
                :
                Message.warning(MESSAGE.CSCORE_KHONG_CO_QUYEN_TRUY_CAP)
        }

    }

    renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const RADIAN = Math.PI / 180;
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${(percent * 100).toFixed(2)}%`}
            </text>
        );
    };

    render() {
        const COLORS = ["#52c41a", '#faad14', '#f5222d', '#faad14', '#f4953f'];
        const { data_gp, data_bcdk, tittle, tieude, data } = this.state

        return (
            <div>
                <div className="tieudetrangchu" >
                    {tittle}
                </div>
                <div className="tieudegp">
                    {tieude}
                </div>
                {data_gp && data_gp.filter(x => x.name === "").length > 0 ?
                    <div onClick={() => this.handleClick(data_gp[0].name_1)} className="bvmt">
                        {data_gp[0].name_1 + " " + data_gp[0].value_qd}
                    </div>
                    :
                    <Row className="bieudotronmb">
                        <Row>

                            <Col className="bieudosolieu">

                                <PieChart width={200} height={200}>
                                    <Pie
                                        data={data_gp}
                                        labelLine={false}
                                        label={this.renderCustomizedLabel}
                                        outerRadius={80}
                                        fill="#8884d8"
                                        legendType='circle'
                                    >
                                        {
                                            data_gp.map((entry, index) => <Cell fill={COLORS[index % COLORS.length]} onClick={() => this.handleClick(entry.name)} />
                                            )
                                        }
                                    </Pie>
                                    <Tooltip />
                                </PieChart>
                            </Col>
                        </Row>

                        <Row style={{ paddingLeft: 50 }}>
                            <Col className="chuthich">
                                <div style={{ cursor: "pointer" }} onClick={() => this.handleClick(data_gp[0].tittle_tong)}>
                                    <Row type="flex">
                                        <Col>
                                            Tổng số:
                                        </Col>
                                        <Col style={{ paddingLeft: 5 }}>
                                            {data_gp && data_gp.length > 0 && data_gp[0].value_tong
                                            }
                                        </Col>
                                    </Row>


                                </div>

                                {
                                    data_gp.map((item, index) => <div className="chuthichtitle" onClick={() => this.handleClick(item.name)}><div className="titlechuthich" style={{ background: item.backGroundColor }} />{item.name + ": " + item.value}</div>
                                    )

                                }
                                <div style={{ paddingTop: 5, cursor: "pointer" }} onClick={() => this.handleClick(data_gp[0].tittle_cgbc)}>
                                    <Row type="flex">
                                        <Col style={{ color: "#D22222" }}>
                                            Chưa gửi báo cáo:
                                        </Col>
                                        <Col style={{ marginLeft: 5, color: "#D22222" }}>
                                            {data.chuaguibc ? data.chuaguibc : undefined}
                                        </Col>

                                    </Row>

                                </div>

                            </Col>
                        </Row>

                    </Row>}

                <hr></hr>
                <div className="tieudegp">
                    Báo cáo định kỳ
                </div>
                <Row className="bieudotronmb">
                    <Col className="bieudosolieu">
                        <PieChart width={200} height={200}>
                            <Pie
                                data={data_bcdk}
                                labelLine={false}
                                label={this.renderCustomizedLabel}
                                outerRadius={80}
                                fill="#8884d8"
                                legendType='circle'
                                dataKey="value_bcdk"
                            >
                                {
                                    data_bcdk.map((entry, index) => <Cell fill={COLORS[index % COLORS.length]} name={entry.indicatorbcdk} onClick={() => this.handleClick(entry.indicatorbcdk)} />)
                                }
                            </Pie>
                            <Tooltip />
                        </PieChart>
                    </Col>
                    <Row style={{ paddingLeft: 50 }}>
                        <Col className="chuthich">
                            <div style={{ cursor: "pointer" }} onClick={() => this.handleClick(data_bcdk[0].tittle_tong_bcdk)}>
                                <Row type="flex">
                                    <Col>
                                        Tổng số:
                                    </Col>
                                    <Col style={{ paddingLeft: 5 }}>
                                        {data_bcdk && data_bcdk.length > 0 && data_bcdk[0].value_tong_bcdk
                                        }
                                    </Col>
                                </Row>


                            </div>
                            {
                                data_bcdk.map((item, index) => <div className="chuthichtitle" onClick={() => this.handleClick(item.indicatorbcdk)} ><div className="titlechuthich" style={{ background: item.backGroundColor }} />{item.indicatorbcdk + ": " + item.value_bcdk}</div>
                                )
                            }
                        </Col>
                    </Row>
                </Row>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({ user: state.oidc.user });
export default connect(mapStateToProps)(SoLieuBieuDoMB);